import { render, staticRenderFns } from "./news-card.vue?vue&type=template&id=aeb087f0&scoped=true&"
import script from "./news-card.vue?vue&type=script&lang=js&"
export * from "./news-card.vue?vue&type=script&lang=js&"
import style0 from "./news-card.vue?vue&type=style&index=0&id=aeb087f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb087f0",
  null
  
)

export default component.exports